import ProximityCard from './ProximityCard';

interface CorporateHub {
  icon: string;
  title: string;
  distance: string;
  travelTime: string;
  description: string;
  highlights: string[];
  color: string;
}

interface CorporateHubsSectionProps {
  className?: string;
}

const CorporateHubsSection = ({ className = '' }: CorporateHubsSectionProps) => {
  const corporateHubs: CorporateHub[] = [
    {
      icon: 'AcademicCapIcon',
      title: 'IIM Bangalore',
      distance: '160 m',
      travelTime: '1 min drive',
      description: 'Premier business school and executive education center, hosting conferences, workshops, and corporate training programs year-round.',
      highlights: [
        'Executive education programs and workshops',
        'Business conferences and networking events',
        'Research collaborations and consulting opportunities',
        'Alumni network and corporate partnerships',
      ],
      color: 'bg-gradient-to-br from-primary to-secondary',
    },
    {
      icon: 'BuildingOfficeIcon',
      title: 'Electronic City',
      distance: '17 km',
      travelTime: '25 min drive',
      description: "India's first and largest electronic industrial park, home to major IT companies, tech startups, and multinational corporations.",
      highlights: [
        'Infosys, Wipro, TCS headquarters',
        'Over 200 IT and electronics companies',
        'Tech parks and innovation centers',
        'Business process outsourcing hubs',
      ],
      color: 'bg-gradient-to-br from-secondary to-accent',
    },
    {
      icon: 'BuildingOffice2Icon',
      title: 'SJR Primeco Tech Park',
      distance: '850 mtrs',
      travelTime: '4 min drive',
      description: 'Modern business park featuring contemporary office spaces, co-working facilities, and corporate amenities for growing businesses.',
      highlights: [
        'Grade A office spaces and co-working hubs',
        'Startup incubators and accelerators',
        'Conference facilities and meeting rooms',
        'Food courts and business amenities',
      ],
      color: 'bg-gradient-to-br from-accent to-warning',
    },
    {
      icon: 'BriefcaseIcon',
      title: 'Koramangala Business District',
      distance: '7 km',
      travelTime: '25 min drive',
      description: "Koramangala is Bengaluru's premier business and startup hub, offering excellent connectivity and a vibrant urban lifestyle.",
      highlights: [
        'Startup headquarters and venture capital firms',
        'Co-working spaces and innovation labs',
        'Business networking events and meetups',
        'Retail and commercial establishments',
      ],
      color: 'bg-gradient-to-br from-success to-primary',
    },
  ];

  return (
    <section className={`py-16 lg:py-24 bg-white ${className}`}>
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="font-display text-3xl lg:text-5xl font-bold text-text-primary mb-4">
            Corporate Hubs & Business Centers
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            Strategic location connecting you to Bangalore's premier business districts, tech parks, and corporate headquarters. Your office is closer than you think.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {corporateHubs.map((hub, index) => (
            <ProximityCard key={index} {...hub} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default CorporateHubsSection;